"use client";
import { LandingSiteTemplateGetDataCommoditiesItemDataSourceOutputApiModel } from "@/Apis/ClinicApi";
import { Format, If, SmartImage, SmartLink } from "@/Components";
import { CenterOptions } from "@/Helpers/CenterOptions";
import { useImageFallback } from "@/Hooks";
import { FC } from "react";
import { FaEye, FaHeart, FaLayerGroup } from "react-icons/fa";

type CenterItemModel =
  LandingSiteTemplateGetDataCommoditiesItemDataSourceOutputApiModel & {
    DisplayNameInProfile?: string | undefined;
  };

interface CenterItemProps {
  model: CenterItemModel;
  Currency?: number;
}

const CenterItem: FC<CenterItemProps> = ({ model, Currency }) => {
  const getImageFallback = useImageFallback();
  const displayName = model.DisplayNameInProfile || model.Name;

  return (
    <div className="item">
      <div className="store-item">
        <div className="store-img">
          <SmartLink href={model.Link}>
            <SmartImage
              cover
              width={276}
              height={250}
              src={getImageFallback({
                imageUrl: model.Image?.Url,
                entity: "CenterItem",
              })}
              alt={model.Image?.AltText ?? displayName}
              className="img-fluid"
              objectFit="contain"
            />
          </SmartLink>
          {/* <span className="glass-cat">Power Glass</span> */}
          {/* <span className="store-cat">جدید</span> */}
          <div className="overlay-top-items">
            <SmartLink href="#" className="fav-icon">
              <FaHeart />
            </SmartLink>
            <SmartLink href={model.Link}>
              <FaEye />
            </SmartLink>
            <SmartLink href="#">
              <FaLayerGroup />
            </SmartLink>
          </div>
        </div>
        <div className="store-content">
          <h4>
            <SmartLink href={model.Link}>{displayName}</SmartLink>
          </h4>
          <p>{model.ShortDescription}</p>
          <If
            condition={
              model.PriceDisplayStatusKey == CenterOptions.Enum.Status.Active.key
            }
          >
            <div className="price-tag">
              <h5>
                <Format
                  type="Number"
                  value={model.SpecialSalePrice ?? model.SalePrice}
                  currency={Currency}
                />
              </h5>
              {/* <ul className="color-selection">
                                                <li>
                                                    <span className="black-glass">
                                                        <FaCircle />
                                                    </span>
                                                </li>
                                                <li>
                                                    <span className="blue-glass">
                                                        <FaCircle />
                                                    </span>
                                                </li>
                                            </ul> */}
            </div>
          </If>
        </div>
      </div>
    </div>
  );
};

export default CenterItem;
